import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const squareBadgeDefinition: BoggleBadgeDefinition = {
  category: 'path',
  description: 'Play a word using each tile in a 2x2 square',
  iconId: 'square',
  id: 'square',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Square',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
